import React from 'react';

import { generateItemCardPlaceholders } from 'tradera-components/item-card/generate-item-card-placeholders';
import ItemCard from 'tradera-components/item-card/item-card';
import { lazyLoadSettings } from 'tradera-components/item-card/config';
import LoadingIcon from '@tradera/blueprint/theme/icons2/loading.svg?jsx';
import useIsMobile from 'tradera-hooks/use-is-mobile';

const LoadingSymbolSpinner = () => (
    <div className={`col-12 d-flex text-center loader-container`}>
        <LoadingIcon className="d-flex mx-auto icon icon-xl icon-spin m-auto" />
    </div>
);

const LoadingSymbolCards = ({ itemsPerPage }) => {
    const items = generateItemCardPlaceholders(itemsPerPage);
    const localLazyLoadSettings = {
        ...lazyLoadSettings,
        offset: 100
    };

    const isMobile = useIsMobile();

    return (
        <div
            className={`item-card-layout d-flex ${
                isMobile
                    ? 'layout-scroll flex-nowrap overflow-x-auto'
                    : 'layout-grid flex-wrap'
            }`}>
            {items.map(item => (
                <div
                    key={item.itemId}
                    className="item-card-container flex-shrink-0">
                    <ItemCard
                        item={item}
                        lazy={localLazyLoadSettings}
                        ready={false}
                    />
                </div>
            ))}
        </div>
    );
};

export { LoadingSymbolSpinner, LoadingSymbolCards };
